/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2026-03-23 09:36:51
 */
export const CURRENT_CONFIG = {
  // license
  appId: "128254", // You need to go to the development website to apply.
  appKey: "7d1ca7e7c5de707426d5d4f5d28030a", // You need to go to the development website to apply.
  appLicense:
    "TROvL+uAHaqzumT2yPGhwKKapD2hlWW6xCOXxbIC/S7S5dVvw3+UxGAeLzN1ZZkE0OLTEq1hTNJ0MkIdkqxSIO1/j/A0dwEMqkfHdn9sBuDNS6JGHwokzlHJEZCEuUO9jVWoEXo0bSelm8hp21mzSqcAyVxVg2S9Zum1qMG8Pkg=", // You need to go to the development website to apply.

  // 线上
  baseURL:
    (window as any).ConfigManage?.baseURL || "https://fly.cdjjhb.cn:8085/", // fly
  websocketURL:
    (window as any).ConfigManage?.websocketURL ||
    "wss://fly.cdjjhb.cn:8085/api/v1/ws", // fly
  aiWebsocketURL:
    (window as any).ConfigManage?.aiWebsocketURL ||
    "wss://fly.cdjjhb.cn/ai/api/ws", // fly
  // baseURL:
  //   (window as any).ConfigManage?.baseURL ||
  //   "http://125.70.13.132:8086/backstage/", // 科尔沁
  // websocketURL:
  //   (window as any).ConfigManage?.websocketURL ||
  //   "ws://125.70.13.132:8086/backstage/api/v1/ws", // 科尔沁
  // baseURL:
  //   (window as any).ConfigManage?.baseURL ||
  //   "http://223.86.29.68:27017/backstage/", // 广汉
  // websocketURL:
  //   (window as any).ConfigManage?.websocketURL ||
  //   "ws://223.86.29.68:27017/backstage/api/v1/ws", // 广汉
  // baseURL: (window as any).ConfigManage?.baseURL || "http://183.222.76.133:8086/backstage/", // 资中
  // websocketURL: (window as any).ConfigManage?.websocketURL || "ws://183.222.76.133:8086/backstage/api/v1/ws", // 资中
  // baseURL: (window as any).ConfigManage?.baseURL || "http://118.122.112.58:30080/backstage/", // 成华 外网
  // websocketURL: (window as any).ConfigManage?.websocketURL || "ws://118.122.112.58:30080/backstage/api/v1/ws", // 成华 外网
  // baseURL: (window as any).ConfigManage?.baseURL || "http://192.168.68.2:30080/backstage/", // 成华 内网
  // websocketURL: (window as any).ConfigManage?.websocketURL || "ws://192.168.68.2:30080/backstage/api/v1/ws", // 成华 内网
  // baseURL: (window as any).ConfigManage?.baseURL || "http://221.179.250.5:8086/backstage/", // 拉萨 无ai
  // websocketURL: (window as any).ConfigManage?.websocketURL || "ws://221.179.250.5:8086/backstage/api/v1/ws", // 拉萨 无ai

  // 代理地址
  quanUrl:
    (window as any).ConfigManage?.quanUrl ||
    "https://fly.cdjjhb.cn:8085/minioFile", // 文件下载 与baseUrl保持一致 fly
  // quanUrl:
  //   (window as any).ConfigManage?.quanUrl ||
  //   "http://125.70.13.132:8086/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 科尔沁
  // quanUrl:
  //   (window as any).ConfigManage?.quanUrl ||
  //   "http://223.86.29.68:27017/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 广汉
  // quanUrl: (window as any).ConfigManage?.quanUrl || "http://183.222.76.133:8086/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 资中
  // quanUrl: (window as any).ConfigManage?.quanUrl || "http://118.122.112.58:30080/backstage/minioFile", // 文件下载 与baseUrl保持一致 成华 外网
  // quanUrl: (window as any).ConfigManage?.quanUrl || "http://192.168.68.2:30080/backstage/minioFile", // 文件下载 与baseUrl保持一致 成华 内网
  // quanUrl: (window as any).ConfigManage?.quanUrl || "http://221.179.250.5:8086/backstage/minioFile", // 文件下载 与baseUrl保持一致 拉萨 无ai
  // quanUrl: (window as any).ConfigManage?.quanUrl || 'http://192.168.1.15:8085/minioFile',
  // 文件服务 key
  bucket: "ga-bucket",
  // aiBaseUrl:
  //   (window as any).ConfigManage?.aiBaseUrl || "http://125.70.13.132:8086/", // 后端ai项目 科尔沁
  // aiBaseUrl:
  // (window as any).ConfigManage?.aiBaseUrl || "http://223.86.29.68:27017/", // 后端ai项目 广汉
  // aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "http://183.222.76.133:8086/", // 后端ai项目 资中
  // aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "http://118.122.112.58:30080/", // 成华 外网
  // aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "http://192.168.68.2:30080/", // 成华 内网
  aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "https://fly.cdjjhb.cn/", // 后端ai项目 fly
  // aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "http://221.179.250.5:8086/", // 无ai
  // aiBaseUrl: (window as any).ConfigManage?.aiBaseUrl || "/aiBaseUrl", // 本地测试
  // dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "/dbBaseUrl", // 后台 db 地址
  dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "https://fly.cdjjhb.cn/zbt/", // 后台 db 地址 fly
  // dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "http://183.222.76.133:8086/zbt/", // 后台 db 地址 资中
  // dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "http://118.122.112.58:30080/zbt/", // 后台 db 地址 成华 外网
  // dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "http://192.168.68.2:30080/zbt/", // 后台 db 地址 成华 内网
  // dbBaseUrl:
  //   (window as any).ConfigManage?.dbBaseUrl || "http://223.86.29.68:27017/zbt/", // 后台 db 地址 广汉
  // dbBaseUrl:
  //   (window as any).ConfigManage?.dbBaseUrl || "http://125.70.13.132:8086/zbt/", // 后台 db 地址 科尔沁
  // dbBaseUrl: (window as any).ConfigManage?.dbBaseUrl || "http://221.179.250.5:8086/zbt/", // 后台 db 地址 拉萨 无ai

  // msBaseUrl: (window as any).ConfigManage?.msBaseUrl || "/msBaseUrl", //  妙算 本地测试
  msBaseUrl:
    (window as any).ConfigManage?.msBaseUrl || "https://fly.cdjjhb.cn/m3/", //  妙算 线上 fly

  // video_output_url // 打包时需要注意离线视频的参数修改，全局搜索 video_output_url

  // 首页名称
  // name: (window as any).ConfigManage?.name || "岑睿无人机管控平台", // 成华
  name: (window as any).ConfigManage?.name || "瑞特无人机管控平台", //fly
  // name: (window as any).ConfigManage?.name || "天枢航控低空运营服务平台", // 广汉
  // name: (window as any).ConfigManage?.name || "九章智控平台", // 九章
  reportBaseUrl: "https://zk.cdrzwx.cn/", // 报告地址
  vedioPrefix: "http://ga.cdrzwx.cn:9003/ga-bucket/", //生成任务时 视频地址 前缀
  // copy right
  copyrightName:
    (window as any).ConfigManage?.copyrightName || "成都瑞兹无线科技有限公司",
  // copyrightName: (window as any).ConfigManage?.copyrightName || "四川岑睿科技有限公司", // 成华
  // copyrightName: (window as any).ConfigManage?.copyrightName || "四川九洲软件有限公司", // 九章
  logoNum: (window as any).ConfigManage?.logoNum || 1, // 1 为默认；2为成华；3为九章
  // go2rtc ai视频播放
  // webRtcStreamerUrL: (window as any).ConfigManage?.webRtcStreamerUrL || "http://183.222.76.133:1974", // go2rtc 地址，用于播放rtsp视频 资中
  // webRtcStreamerUrL:
  //   (window as any).ConfigManage?.webRtcStreamerUrL ||
  //   "http://223.86.29.68:27017", // go2rtc 地址，用于播放rtsp视频 广汉
  // webRtcStreamerUrL: (window as any).ConfigManage?.webRtcStreamerUrL || "http://118.122.112.58:30080", // go2rtc 地址，用于播放rtsp视频 成华 外网
  // webRtcStreamerUrL: (window as any).ConfigManage?.webRtcStreamerUrL || "http://192.168.68.2:30080", // go2rtc 地址，用于播放rtsp视频 成华 内网
  // webRtcStreamerUrL:
  //   (window as any).ConfigManage?.webRtcStreamerUrL ||
  //   "http://125.70.13.132:8086", // go2rtc 地址，用于播放rtsp视频 科尔沁
  webRtcStreamerUrL:
    (window as any).ConfigManage?.webRtcStreamerUrL || "https://fly.cdjjhb.cn", // go2rtc 地址，用于播放rtsp视频 fly
  // webRtcStreamerUrL: (window as any).ConfigManage?.webRtcStreamerUrL || "http://221.179.250.5:8086", // go2rtc 地址，用于播放rtsp视频 拉萨 无ai

  // webRtcStreamerWs: (window as any).ConfigManage?.webRtcStreamerWs || "api/ws?src=", // go2rtc 地址，用于连接 websocket https需要 go2rtc/，http则去掉 资中
  webRtcStreamerWs:
    (window as any).ConfigManage?.webRtcStreamerWs || "go2rtc/api/ws?src=", // go2rtc 地址，用于连接 websocket https需要 go2rtc/，http则去掉 广汉、fly、成华 、科尔沁
  // name: '无人机管控平台',
  layout: (window as any).ConfigManage?.layout || {
    driveFlyFlag: true, //御4 飞行页面 true为显示 false不显示
    statusJob: "1", // 任务管理-排序 排序 0:未执行；1已执行 科尔沁设置为0，其余设置为1
    pushFlag: false, // 广汉推送，广汉设置为 true，其余设置为 false
    aigisFlag: true, // 大屏aigis区域是否加载，
    aiAllFlag: true, // 项目是否开启ai相关的功能 true为开启，false为关闭，拉萨为false，其余为true
    msAllFlag: true, // 项目是否开启妙算相关的功能 true为开启，false为关闭
  },
  iframeUrl:
    "https://cloud.hfuav.com/#/Implant/correspondentLogin.html?userName=18283837113&key=3FZHKtp1CKYYBMPfuzyS&&sign=0ea16d1f5c4eeab5d31500495138c617&type=1", // iframe地址

  // livestreaming   rtmp://你电脑的 ip 地址/live   rtmp://1.14.163.252:1935/rtc/v1/play/
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // rtmpURL: 'rtmp://192.168.1.100/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  rtmpURL: "rtmp://117.174.109.131/live/", // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://ga.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://rt.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://yd.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: "132.232.53.29", // 服务器IP
  gbServerPort: "5060", // 服务器端口
  gbServerId: "44010200492000000001", // 服务器ID
  gbAgentId: "admin1", // 客户帐号
  gbPassword: "123456", // 密码
  gbAgentPort: "5060", // 本地端口
  gbAgentChannel: "34020000001320000100", // 通道号
  // RTSP
  rtspUserName: "admin",
  rtspPassword: "admin123",
  rtspPort: "554",
  // Agora
  agoraAPPID: "Please enter the agora app id.",
  agoraToken: "Please enter the agora temporary token.",
  agoraChannel: "Please enter the agora channel.",
  // map
  // You can apply on the AMap website. 80318ebe8ce042d5fdb5cebd7ff52acc
  amapKey: "ae8cd277a7d81c74b92cdea8bb2ba712", //高德地图key
  // amapKey: '80318ebe8ce042d5fdb5cebd7ff52acc', //高德地图key

  // 语音功能配置
  voice: {
    /** 是否启用语音唤醒功能 */
    enableVoiceWake: false,
    /** 是否启用语音对话功能 */
    enableVoiceDialogue: false,
    /** 默认唤醒词 */
    defaultWakeWord: "同学",
    /** 默认录音时长（毫秒） */
    defaultRecordDuration: 3000,
    /** 音量阈值 */
    volumeThreshold: 40,
    /** 静音时长（毫秒） */
    silenceDuration: 2000,
    /** 请求超时时间（毫秒） */
    requestTimeout: 20000,
    /** 最小音频大小（字节） */
    minAudioSize: 5000,
  },

  // AI大模型配置
  ai: {
    baseUrl: "/chatUrl", // 代理
    /** 使用的AI服务：qwen(通义千问) | wenxin(文心一言) | spark(讯飞星火) */
    provider: "qwen",
    /** API密钥 - 请替换为你的实际密钥 */
    apiKey: "sk-262b4835547145f083b9c8e617b70fa6",
    /** 模型名称 */
    model: "qwen-turbo",
    /** 系统提示词 */
    systemPrompt:
      "你是一个智能助手，专注于帮助用户解决无人机管控平台相关的问题。你可以回答关于天气、设备状态、任务管理等方面的问题。请用简洁、专业的语言回答。",
    /** TTS语音合成配置 */
    tts: {
      enabled: true, // 是否启用TTS
      autoPlay: false, // 是否自动播放AI回复
      voice: "zhichu", // 默认音色：zhichu(智楚-温柔女声), zhitian(知甜), zhimi(知米), zhixiang(知翔-男声), zhishuo(知硕-男声)
      volume: 50, // 默认音量 0-100
      speechRate: 0, // 默认语速 -500到500
      pitchRate: 0, // 默认音调 -500到500
      format: "mp3", // 音频格式：mp3, wav, pcm
      sampleRate: 16000, // 采样率：8000, 16000, 24000, 48000
    },
  },

  // WebRTC 视频播放配置
  webrtc: (window as any).ConfigManage?.webrtc || {
    /** 是否为内网环境 - true: 使用原生WebRTC播放器并修正SDP; false: 使用jswebrtc库 */
    isIntranet: false,
    /** WebRTC UDP端口 - Docker映射的UDP端口，用于SDP candidate修正 */
    udpPort: "38000",
    /** STUN服务器配置 */
    stunServers: [{ urls: "stun:stun.l.google.com:19302" }],
  },
};
